<div class="modal-header">
  <h4 class="modal-title">{{'BUY_EXTRA' | translate}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="done.emit()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="app-content content container-fluid left">
  <div class="content-wrapper">
    <div class="content-body">
      <ngb-alert type="warning" [dismissible]="false" *ngIf="user?.service_type === 'TDLTE'">
        <strong>{{'WARNING' | translate}}: </strong>{{'REMAINING_EXTRA_NOT_TRANSFERABLE' | translate}}
      </ngb-alert>
      <ngb-alert type="success" [dismissible]="false" *ngIf="user?.service_type !== 'TDLTE'">
        <strong>{{'DONT_WORRY' | translate}}: </strong>{{'REMAINING_EXTRA_TRANSFERABLE' | translate}}
      </ngb-alert>
      <div class="row">
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 offset-sm-0" *ngFor="let extra of extras">
          <div class="card itemAdd box-shadow-2">
            <div *ngIf="extra.traffic" class="card-header text-center">
              <h2>
                {{ extra.traffic | bytes }}
              </h2>
              <h4 *ngIf="user.is_fup">
                {{ 'EQUALS' | translate }} {{ extra.traffic / 2 | bytes }} {{ 'INTERNATIONAL' | translate }}
              </h4>
              <h4 *ngIf="!user.is_fup && !user.is_super">
                {{ 'EQUALS' | translate }} {{ extra.traffic * 2 | bytes }} {{ 'INTERNAL' | translate }}
              </h4>
              <h4 *ngIf="user.is_super">
                {{ 'EQUALS' | translate }} {{ extra.traffic * 2.68 | bytes }} {{ 'INTERNAL' | translate }}
              </h4>
            </div>
            <div class="card-body text-center">
              <button class="btn btn-outline-primary" (click)="addInvoice(extra.id)">
                <i class="fa fa-shopping-basket"></i>
                {{extra.price | money: translator.getDefaultLang() }}
              </button>
              <br />
              <a *ngIf="extra.cra_id" href="https://etebar-basteh.cra.ir/?OperatorId=72&PackCode={{extra.cra_id}}"
                target="{{extra.cra_id}}">{{'CRA_VALIDATION' | translate}}</a>
            </div>
          </div>

        </div>
      </div>

    </div>